
<div class="skeleton-card ng-card-content">
  <div class="skeleton skeleton-1"></div>
  <div class="skeleton skeleton-2"></div>
  <div class="skeleton skeleton-3"></div>
  <div class="skeleton skeleton-4"></div>
  <div class="skeleton skeleton-5"></div>
  <div class="skeleton skeleton-6"></div>
  <div class="skeleton skeleton-7"></div>
  <div class="skeleton skeleton-8"></div>
  <div class="skeleton skeleton-9"></div>
  <div class="skeleton skeleton-10"></div>
  <div class="skeleton skeleton-11"></div>
  <div class="skeleton skeleton-12"></div>
  <div class="skeleton skeleton-13"></div>
</div>

<div class="skeleton-card ng-card-content">
  <div class="skeleton skeleton-1"></div>
  <div class="skeleton skeleton-2"></div>
  <div class="skeleton skeleton-3"></div>
  <div class="skeleton skeleton-4"></div>
  <div class="skeleton skeleton-5"></div>
  <div class="skeleton skeleton-6"></div>
  <div class="skeleton skeleton-7"></div>
  <div class="skeleton skeleton-8"></div>
  <div class="skeleton skeleton-9"></div>
  <div class="skeleton skeleton-10"></div>
  <div class="skeleton skeleton-11"></div>
  <div class="skeleton skeleton-12"></div>
  <div class="skeleton skeleton-13"></div>
</div>

<div class="skeleton-card ng-card-content">
  <div class="skeleton skeleton-1"></div>
  <div class="skeleton skeleton-2"></div>
  <div class="skeleton skeleton-3"></div>
  <div class="skeleton skeleton-4"></div>
  <div class="skeleton skeleton-5"></div>
  <div class="skeleton skeleton-6"></div>
  <div class="skeleton skeleton-7"></div>
  <div class="skeleton skeleton-8"></div>
  <div class="skeleton skeleton-9"></div>
  <div class="skeleton skeleton-10"></div>
  <div class="skeleton skeleton-11"></div>
  <div class="skeleton skeleton-12"></div>
  <div class="skeleton skeleton-13"></div>
</div>
